/**
 * Created by zzy on 2019/8/5.
 */
import LowVoltageDetection from './LowVoltageDetection.vue'
export default LowVoltageDetection



// WEBPACK FOOTER //
// ./src/views/monitoring/lowVoltageDetection/index.js